export const ProjectKey = {
  ToneFlood: 'toneflood',
  ToneLowFlow: 'tonelowflow',
  Fukuoka: 'fukuoka',
  Nagano: 'nagano',
} as const;

export type ProjectKey = (typeof ProjectKey)[keyof typeof ProjectKey];
